export const LoginDetailsReducer = (state = [], action) => {
  switch (action.type) {
    case `SET_HITP_LOGIN_DETAILS`:
      return action.payload;
    default:
      return state;
  }
};